import { render } from "./BMediaBody.vue?vue&type=template&id=7c1144a8"
import script from "./BMediaBody.vue?vue&type=script&lang=js"
export * from "./BMediaBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__